import React, { useContext, useState, useEffect } from "react"
import { useQueryParam, StringParam } from "use-query-params"
import { navigate } from "gatsby-link"
import {Link} from 'gatsby'
import short from "short-uuid"
import useCookie from "./../../hooks/useCookie";
import {updateConsent} from "./../../utils/utilityFunctions";
import { ChildAPIContext, checkLoggedIn, getChildID } from './../../utils/childapi'
import FormInput from "./../../components/FormInput/FormInput"
import { validate_password } from "./../../utils/validiiations"
import  phonesmartFunHand from "./../../images/phonesmartfun-hand.png"

import "./KidsLogin.scss"


const KidsHomeDefaultBanner = () => {
	const isParentLoggedIn = (typeof window !== "undefined") && window.localStorage.getItem("cognito_user");

	return (
		<div className="kids-not-register">
			<img src={phonesmartFunHand} alt="Fun hand" />
			<h1>GET your PHONESMART licence</h1>
			<div><p>Hi, and welcome to your wonderful new phone world. It's gonna be great. And once you've got your PhoneSmart Licence it'll be even better.</p></div>
			<div className="sign-up">
				<h2>It’s easy to join</h2>
				<p>{`Just ask your parent or a trusted grown-up to `}
				<Link to={`/register/`} className="dotted-link"
				data-analytics='{"event":"GrownupEngagement", "eventCategory":"Child Homepage- Engagement", "eventAction":"Link Click - Sign up", "eventLabel":"Register you here"}'>register you here.</Link>
				</p>
				<h2>Already signed up? </h2>
				<p>{`Brilliant. Ask your parent or a trusted grown-up to `}
				{(isParentLoggedIn === 'null')
        ? <Link to={`/register/`} state={{ goToElement: 'login' }} className="dotted-link"
		data-analytics='{"event":"GrownupEngagement", "eventCategory":"Child Homepage- Engagement", "eventAction":"Link Click - Log in", "eventLabel":"Log on"}'>log on here</Link>
        : <Link to={`/account/`} className="dotted-link"
		data-analytics='{"event":"GrownupEngagement", "eventCategory":"Child Homepage- Engagement", "eventAction":"Link Click - Account", "eventLabel":"Log on"}'>log on here</Link>
      	}
				, get your unique link and then let’s go!
				</p>
			</div>
		</div>
	)
}

const KidsHomeLoggedInBanner = () => {
	const {childAPI} = useContext(ChildAPIContext)
	const [childAPIState, childAPIdispatch] = childAPI;    // eslint-disable-line no-unused-vars
	
	const Logout = () =>   childAPIdispatch({ action: "logout-child",  data: { } });

	return (
		<div>
			<p>You have logged in. You can now go to the <Link to={`/kids/dashboard/`}>Dashboard</Link></p>
			<button onClick={Logout} className="btn btn-gray d-block">Log Out</button>
		</div>
	)
}

const KidsHomeRegisteredBanner = ({childUUID}) => {
	const [c, setConsent] = useQueryParam("c", StringParam);
	const [u, setUid] = useQueryParam("u", StringParam);    // eslint-disable-line no-unused-vars
	localStorage.setItem("uid", u);
	localStorage.setItem("userConsent", c);
	const [userCookie] = useCookie(process.env.GATSBY_USER_COOKIE);
	const [userConsentCookie, setUserConsentCookie] = useCookie(process.env.GATSBY_USER_CONSENT_COOKIE);

	const {childAPI} = useContext(ChildAPIContext)
	const [childAPIState, childAPIdispatch] = childAPI;
	const [displyPassword, setDisplyPassword] = useState('hide');
	const [state, setState] = useState({
		password: "",
		errors: {},
		isValid: {
			password: false,
		}
	});

	const validate = (e) => {
		e.preventDefault();
		const newState = { ...state }

		return newState.isValid.password;
	}


	const validatePassword = (v) => {
		const newState = {...state};
		const [valid, msg] = validate_password(v);

		if(valid){
			newState.password = msg;
			newState.errors.password = "";
			newState.isValid.password= true;
		} else if (!valid) {
			newState.isValid.password= false;
			newState.errors.password = msg;
			newState.isValid.password= false;

		}
		setState(newState);
	}

	const togglePasswordDisplay = (e) => {
		if(displyPassword === 'show') {
			setDisplyPassword('hide');
		} else {
			setDisplyPassword('show');
		}
	}

	const loginDispatcher = () => {
		const newState = {...state};
		
		if(c==='y') {
			setUserConsentCookie(process.env.GATSBY_USER_CONSENT_COOKIE_ACCEPT)
			updateConsent(userCookie, process.env.GATSBY_USER_CONSENT_COOKIE_ACCEPT, 1)
		} else if(c==='n'){
			setUserConsentCookie(process.env.GATSBY_USER_CONSENT_COOKIE_REJECT)
			updateConsent(userCookie, process.env.GATSBY_USER_CONSENT_COOKIE_REJECT, 2)
		}

		childAPIdispatch({
			action: "login-child",
			data: {
			  child: childUUID,
			  password: newState.password
			}
		})
  };

	const handleKeyPress = (e) => {

		if(e.keyCode === 13){
			if(validate(e)) {
				loginDispatcher();
			}
		}
	}


  if(childAPIState?.auth_token) {
		return <KidsHomeLoggedInBanner />
	} else {
		return (
		<>
		<div className="kids-login-banner">
		<img src={phonesmartFunHand} alt="Fun hand" />
			<h2>Hello</h2>
			<h2>{ childAPIState?.nickname ? childAPIState.nickname : null }</h2>
			<p className="bold title">Just enter your password to get started.</p>
			{ childAPIState?.error ? <div className="error-msz">{childAPIState.error?.message}</div> : null }
			<div className="password-wrapper">
				<FormInput type={displyPassword === "show" ? "text" : "password"} name="password" label="Password" id="loginPassword" state={state}
					updateState={(e) => { validatePassword(e.currentTarget.value); }} keyPress={(e) => { handleKeyPress(e)}} >
					<span className={`show-hide-password ${displyPassword}`} onClick={togglePasswordDisplay}></span>
				</FormInput>
			</div>
			<button className="btn btn-inset-border d-block log-in" onClick={validate && loginDispatcher}>Log on</button>
			<div className="footer-section">
			<p className="bold">Forgot your password?</p>
			<p>No worries. Please ask your parent or a trusted grown up to help.</p>
			<p className="bold mt-4">This isn't You?</p>
			<p>No worries. Please ask your parent for your unique URL. They can also change your nickname, if you don't like it</p>
			</div>

		</div>
		</>
		)
	}
}


const KidsLogin = () => {
  const {childAPI} = useContext(ChildAPIContext)
  const [childAPIState, childAPIdispatch] = childAPI;
  const [uuid, setAddress] = useQueryParam("u", StringParam);    // eslint-disable-line no-unused-vars
  const [requestSent, setRequestSent] = useState(false)
  const translator = short();
  const decodedUUID = (uuid)?translator.toUUID(uuid):getChildID();

	
	useEffect(() => {
		if(!childAPIState?.nickname && decodedUUID && !requestSent) {
			childAPIdispatch({  action: "get-nickname", data: { child: decodedUUID}})
			setRequestSent(true)
		}
	}, [childAPIState, childAPIdispatch, decodedUUID, requestSent])

	useEffect(() => {
		if(checkLoggedIn())	{
			if(decodedUUID && childAPIState.child !== decodedUUID) {
				childAPIdispatch({ action: "logout-child",  data: { } });
			} else if(checkLoggedIn()) {
				return ( <> {navigate('/kids/dashboard/')} </> )
			}
		}
	}, [decodedUUID, childAPIState, childAPIdispatch])

  if(childAPIState?.nickname && decodedUUID){
		return <KidsHomeRegisteredBanner childUUID={decodedUUID}/>
	} else {
		return <KidsHomeDefaultBanner  />
	}
}

export default KidsLogin
